import React, { memo, useRef, useEffect, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import nl from 'date-fns/locale/nl';
import ArrowDownIcon from '../svg/ArrowDownIcon';
import CloseIcon from '../svg/CloseIcon';
registerLocale('nl', nl);

import { today, getThisWeekend } from '../../utils/helpers';
import config from '../../Config';

const FilterbarMob = ({
	memoizedActiveFilterDate,
	memoizedActiveTimestamp,
	memoizedDateRange,
	memoizedActiveCategories,
	memoizedActiveTags,

	availableDates,
	availableCategories,
	availableTags,
	setCategorySelected,
	categorySelected,

	setDateParam,
	setDateRangeParam,
	setCategoriesParam,
	setTagsParam,
	setActiveTags,
	resetParams,
	showModal,
	setShowModal,
	rootElement,
	filteredElements,
}) => {
	const ref = useRef(null);



	const toggleModal = (modalId) => {
		setShowModal((prevModal) => (prevModal === modalId ? null : modalId));
	};

	// Hook om te detecteren of er buiten de modal wordt geklikt
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (ref.current && !ref.current.contains(event.target) && !event.target.closest('.btn')) {
				setShowModal(null);
			}
		};

		// Event listener toevoegen
		document.addEventListener('mousedown', handleClickOutside);

		// Event listener opruimen bij unmounten
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [ref, setShowModal]);

	useEffect(() => {
		const buttons = document.querySelectorAll('.tag--sub-genre');

		const handleClick = (event) => {
		  buttons.forEach(btn => btn.classList.remove('tag--active'));
		  if (!event.currentTarget.classList.contains('tag--active')) {
			 event.currentTarget.classList.add('tag--active');
		  }
		};

		buttons.forEach(button => {
		  button.addEventListener('click', handleClick);
		});

		// Cleanup event listeners on component unmount
		return () => {
		  buttons.forEach(button => {
			 button.removeEventListener('click', handleClick);
		  });
		};
	 }, []);

	const handlePresetDateClick = (preset) => {
		if (preset === 'today') {
			setDateParam(today);
			setDateRangeParam(null);
			// } else if (preset === 'tomorrow') {
			// 	setDateParam(getTomorrow(today));
			// 	setDateRangeParam(null);
		} else if (preset === 'this week') {
			setDateParam(today);
			setDateRangeParam('week');
		} else if (preset === 'this month') {
			setDateParam(today);
			setDateRangeParam('month');
		} else if (preset === 'this weekend') {
			setDateParam(getThisWeekend(today));
			setDateRangeParam('weekend');
		}
	};

	const isActivePreset = (preset) => {
		if (memoizedActiveFilterDate) {
			if (memoizedActiveTimestamp === today) {
				if (memoizedDateRange) {
					if (`this ${memoizedDateRange}` === preset) return true;
				} else {
					if (preset === 'today') return true;
				}
			}
			// if (memoizedActiveTimestamp === getTomorrow(today) && !memoizedDateRange) {
			// 	if (preset === 'tomorrow') return true;
			// }
			if (memoizedActiveTimestamp === getThisWeekend(today)) {
				if (preset === 'this weekend' && memoizedDateRange === 'weekend') return true;
			}
		}
	};

	const handleDatepickerClick = (date) => {
		setDateParam(date.getTime());
		setDateRangeParam(null);
	};

	const handleParamClick = (value, group) => {
		const [formattedValue] = Object.values(value);

		if (group === 'category') {
			setCategorySelected(true);
			setCategoriesParam(formattedValue);
			return;
		}

		if (group === 'tag') {
			const activeTagsValues = memoizedActiveTags.map((tag) => Object.values(tag)[0]);
			const isActive = activeTagsValues.includes(formattedValue);

			if (isActive) {
				setActiveTags([]);
			} else {
				setActiveTags([...memoizedActiveTags, value]);
		  }

			setShowModal(false);
		}
	};

	const filterTagsBasedOnActiveCategory = (data) => {
		if (!Array.isArray(data)) {
			return [];
		}

		const uniqueTags = data.reduce((tagSet, item) => {
			if (item.tags && typeof item.tags === 'object') {
				Object.values(item.tags).forEach((tag) => tagSet.add(tag));
			}
			return tagSet;
		}, new Set());

		return Array.from(uniqueTags).map((tag) => {
			const tagKey = tag
				.toLowerCase()
				.replace(/[^a-z0-9]+/g, '-')
				.replace(/^-|-$/g, '');

			return { [tagKey]: tag };
		});
	};

	// Main function to get parameter labels based on the filter type
	const getParamLabels = (filterType) => {
		let availableItems;
		switch (filterType) {
			case 'category':
				availableItems = availableCategories;
				break;
			case 'tag':
				availableItems = filterTagsBasedOnActiveCategory(filteredElements);
				break;
			default:
				availableItems = availableTags;
		}

		const activeItems = filterType === 'category' ? memoizedActiveCategories : memoizedActiveTags.map((tag) => Object.values(tag)[0]);

		return availableItems.map((item) => ({
			value: item,
			name: Object.values(item)[0],
			active: activeItems.includes(filterType === 'tag' ? Object.values(item)[0] : item),
		}));
	};

	const handleTagClass = (param) => {
		let className = 'tag btn';
		if (param.active) {
			className += ' tag--active';
		}
		return className;
	};

	const handleCategoryClass = (category) => {
		let className = 'tag btn';
		if (category.active) {
			 className += ' tag--active';
		}
		return className;
  };

	return (
		<>
			<div className="agenda-filters">
				<div className="agenda-filters__container">
					<div className="agenda-filter-box agenda-filter-box__datepicker">
						<div className="agenda-filter-box__tags-container">
							{config.date_filter_range &&
								config.date_presets &&
								config.date_presets.map((preset, index) => (
									<button key={index} onClick={() => handlePresetDateClick(Object.keys(preset)[0])} className={isActivePreset(Object.keys(preset)[0]) ? 'tag--active tag btn' : 'tag btn'}>
										<span className="tag__text">{Object.values(preset)[0]}</span>
									</button>
								))}
						</div>

						<button
							onClick={(event) => {
								event.preventDefault();
								toggleModal('datePicker');
						  }}
							role="button"
							className={`agenda-filters__btn btn btn--secondary ${showModal === 'datePicker' ? 'open' : ''}`}
							aria-label="Choose date"
						>
							<span>{customData.i18n.agenda_date_choose} </span>
							<span className="agenda-filters__btn-icon">
								<ArrowDownIcon />
							</span>
						</button>
						{showModal === 'datePicker' && (
							<div ref={ref} className=" agenda-filter-box__tags-modal-pick-date agenda-filters__pick-date-container">
								<div className="agenda-filter-box__tags-container--hide_mobile">
									{config.date_filter_range &&
										config.date_presets &&
										config.date_presets.map((preset, index) => (
											<button
												key={index}
												onClick={() => handlePresetDateClick(Object.keys(preset)[0])}
												className={isActivePreset(Object.keys(preset)[0]) ? 'tag--active tag agenda-filter-box__tag btn' : 'agenda-filter-box__tag tag btn'}
											>
												<span className="tag__text">{Object.values(preset)[0]}</span>
											</button>
										))}
								</div>
								<DatePicker
									selected={memoizedActiveTimestamp}
									onChange={(date) => handleDatepickerClick(date)}
									dateFormat="dd/MM/yyy"
									locale="nl"
									weekStartsOn={2}
									includeDates={availableDates.map((date, index) => {
										if (date >= today) {
											return date;
										}
									})}
									inline
								/>
							</div>
						)}
					</div>

					<div className="agenda-filter-box agenda-filter-box--genre">
						<div className="agenda-filter-box__tags-container">
							<button onClick={() => resetParams(false)} className="tag btn tag--sub-genre tag--active">
								<span className="tag__text">{customData.i18n.agenda_dropdown_all_genres}</span>
							</button>

							{(() => {
									const desiredOrder = ['Klassiek', 'Pop', 'Jazz', 'Wereld', 'Kids'];
									return getParamLabels('category')
										.filter((category) => category.name !== 'Leeg')
										.sort((a, b) => {
											const indexA = desiredOrder.indexOf(a.name);
											const indexB = desiredOrder.indexOf(b.name);
											return indexA - indexB;
										}) // Sorteer de categorieën op basis van de gewenste volgorde
										.map((category, categoryIndex) => {
											const isActive = handleCategoryClass(category).includes('tag--active');
											return (
													<button key={categoryIndex} onClick={() => handleParamClick(category.value, 'category')}
													className={`${handleCategoryClass(category)} tag--sub-genre`}
													aria-pressed={isActive}
													aria-label={isActive ? `Filter: ${category.name}` : undefined}
													>
														<span className="tag__text">{category.name}</span>
													</button>
											);
										});
							})()}
							{memoizedActiveTags.map((item, i) => (
								<button key={i} className={`tag btn tag--active`}>
									<span className="tag__text">{Object.values(item)[0]}</span>
								</button>
							))}
						</div>
						{getParamLabels('tag').length > 0 && (
							<>
								<button onClick={() => toggleModal('resultsModal')} role="button" className={`agenda-filters__btn btn btn--secondary ${showModal === 'resultsModal' ? 'open' : ''}`} aria-label="">
										<span>{customData.i18n.agenda_dropdown_more_genres}</span>
										<span className="agenda-filters__btn-icon">
											<ArrowDownIcon />
										</span>
								</button>
								{showModal === 'resultsModal' && (
										<div ref={ref} className="agenda-filter-box__tags-modal">
											{getParamLabels('tag').map((param, paramIndex) => {
												const isActive = handleTagClass(param).includes('tag--active');
												return (
														<button key={paramIndex} onClick={() => handleParamClick(param.value, 'tag')}
														className={`tag-filter ${handleTagClass(param)}`}
														aria-pressed={isActive}
														aria-label={isActive ? `Filter: ${param.name}` : undefined}
														>
															<span className="tag__text" dangerouslySetInnerHTML={{ __html: param.name }}></span>
														</button>
												);
											})}
										</div>
								)}
							</>
						)}
					</div>

					{/* //only mobile */}
					<div className="agenda-filter-box agenda-filter-box--genre only-mob">


							<>
								<button onClick={() => toggleModal('resultsModal')} role="button" className={`agenda-filters__btn btn btn--secondary ${showModal === 'resultsModal' ? 'open' : ''}`} aria-label="">
										<span>{customData.i18n.agenda_dropdown_all_genres}</span>
										<span className="agenda-filters__btn-icon">
											<ArrowDownIcon />
										</span>
								</button>
								{showModal === 'resultsModal' && (
										<div ref={ref} className="agenda-filter-box__tags-modal--show-on-mobile">
											<div>
												<div className="agenda-filter-box__main-genre-container">
												<button onClick={() => resetParams(false)} className="tag btn">
													<span className="tag__text">{customData.i18n.agenda_dropdown_all_genres}</span>
												</button>

												{(() => {
														const desiredOrder = ['Klassiek', 'Pop', 'Jazz', 'Wereld', 'Kids'];
														return getParamLabels('category')
															.filter((category) => category.name !== 'Leeg')
															.sort((a, b) => {
																const indexA = desiredOrder.indexOf(a.name);
																const indexB = desiredOrder.indexOf(b.name);
																return indexA - indexB;
															}) // Sorteer de categorieën op basis van de gewenste volgorde
															.map((category, categoryIndex) => {
																const isActive = handleCategoryClass(category).includes('tag--active');
																return (
																		<button key={categoryIndex} onClick={() => handleParamClick(category.value, 'category')} className={`${handleCategoryClass(category)} tag--sub-genre`}>
																			<span className="tag__text">{category.name}</span>
																		</button>
																);
															});
												})()}

												</div>
												{categorySelected && (
												<div className="agenda-filter-box__tags-container-mob">
													{getParamLabels('tag').map((param, paramIndex) => {
														const isActive = handleTagClass(param).includes('tag--active');
														return (
																<button key={paramIndex} onClick={() => handleParamClick(param.value, 'tag')}
																className={`tag-filter ${handleTagClass(param)}`}
																aria-pressed={isActive}
																aria-label={isActive ? `Filter: ${param.name}` : undefined}
																>
																	<span className="tag__text" dangerouslySetInnerHTML={{ __html: param.name }}></span>
																</button>
														);
													})}
												</div>
												  )}
										</div>
										</div>
								)}
							</>

					</div>
					<button className="agenda__wis-filter" onClick={() => resetParams(true)}> <CloseIcon/><span className='agenda__wis-filter-text'>{customData.i18n.agenda_empty_filter}</span></button>
				</div>
			</div>
		</>
	);
};

export default memo(FilterbarMob);
